import React from 'react';
export function UniqueMechanism() {
  return <section className="bg-forest-900 py-20 px-4" data-id="element-219">
      <div className="max-w-4xl mx-auto" data-id="element-220">
        <div className="text-center mb-12" data-id="element-221">
          <p className="text-xl md:text-2xl text-forest-50 mb-4" data-id="element-222">
            Hay una razón exacta por la que tu panza se infla todos los días.
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-223">
            Se llama{' '}
            <span className="text-gold-400 block mt-2" data-id="element-224">
              SOBRECRECIMIENTO BACTERIANO EN EL INTESTINO DELGADO.
            </span>
          </h2>
        </div>

        <div className="bg-forest-800 p-8 md:p-12 rounded-3xl shadow-xl border border-forest-800/50 mb-12 text-white" data-id="element-225">
          <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-226">
            Bacterias que deberían vivir en el intestino grueso están viviendo
            donde no deben. Y están comiendo exactamente lo que vos comés: tus
            legumbres, tu fruta, tu ajo, tu cebolla.
          </p>
          <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-227">
            Producen gas. Gas que no puede salir. Gas que te infla como un globo
            a las 7 de la tarde.
          </p>
          <p className="text-xl md:text-2xl font-bold text-gold-400" data-id="element-228">
            No hay dieta ni voluntad que apague eso.
            <br data-id="element-229" />
            Solo el protocolo correcto aplicado en el orden correcto.
          </p>
        </div>
      </div>
    </section>;
}